<div class="UNFAPP-signlog-full-area">
    <div class="UNFAPP-signlog-frm-wrpbx">
        <div class="UNFAPP-signlog-frmbx">
            <div class="UNFAPP-signlog-hdng-wrap">
                <h2 class="UNFAPP-signlog-hdng">Welcome to Infinity Learn</h2>
                <h3 class="UNFAPP-signlog-stphdng">You are 2 steps away from starting your learning journey</h3>
                <!-- <h3 class="UNFAPP-acnt-link-hdng">I already have an account <a href="#">Click here</a></h3> -->
            </div>
    
            <div class="UNFAPP-signlog-tabarea">
                <div class="UNFAPP-signlog-tab-btn-area">
                <ul class="nav nav-tabs" id="myTab" role="tablist">
                    <li class="nav-item" role="presentation">
                        <a class="nav-link" data-toggle="tab" href="#signup" role="tab" >Sign up</a>
                    </li>
                    <li class="nav-item" role="presentation">
                        <a class="nav-link active" data-toggle="tab" href="#signin" role="tab">Sign in</a>
                    </li>
                </ul>
                </div>
                <div class="tab-content" id="myTabContent">
                    <!-- signup -->
                    <div class="tab-pane fade" id="signup" role="tabpanel">
                        <div class="UNFAPP-tab-wrap">
                            <div class="UNFAPP-signlog-form-area">


                                <div class="UNFAPP-form-fld-row">
                                    <div class="UNFAPP-form-fld-wrp UNFAPP-phncuntry-drpdwn UNFAPP-wthicon">
                                        <span class="UNFAPP-frmicon"><img src="images/registration/phone-icon.png" alt="" /></span>
                                        <div class="UNFAPP-phncuntry-fldgrp">
                                            <select>
                                                <option>+91</option>
                                                <option>+91</option>
                                                <option>+91</option>
                                                <option>+91</option>
                                                <option>+91</option>
                                            </select>
                                            <input type="text" placeholder="Phone Number" />
                                        </div>
                                    </div>
                                    <label class="UNFAPP-fld-error">*Account already exists, please click on login to continue</label>
                                </div>


                                <div class="UNFAPP-form-fld-row">
                                    <div class="UNFAPP-form-fld-wrp UNFAPP-wthicon">
                                        <span class="UNFAPP-frmicon"><img src="images/registration/name-icon.png"
                                                alt="" /></span>
                                        <input type="text" class="UNFAPP-form-fld" placeholder="First Name">
                                    </div>
                                </div>
                                <div class="UNFAPP-form-fld-row">
                                    <div class="UNFAPP-form-fld-wrp UNFAPP-wthicon">
                                        <span class="UNFAPP-frmicon"><img src="images/registration/name-icon.png"
                                                alt="" /></span>
                                        <input type="text" class="UNFAPP-form-fld" placeholder="Last Name">
                                    </div>
                                </div>
                                <div class="UNFAPP-signlog-grdarea">
                                    <h3 class="UNFAPP-signlog-hdng lightbold sm-hdng">What grade are you in?</h3>
                                    <ul class="UNFAPP-grdlist-area">
                                        <li>
                                            <label class="UNFAPP-grd-radio">
                                                <input type="radio" name="grade">
                                                <div class="UNFAPP-grd-radiobx">9th</div>
                                            </label>
                                        </li>
                                        <li>
                                            <label class="UNFAPP-grd-radio">
                                                <input type="radio" name="grade">
                                                <div class="UNFAPP-grd-radiobx">10th</div>
                                            </label>
                                        </li>
                                        <li>
                                            <label class="UNFAPP-grd-radio">
                                                <input type="radio" name="grade">
                                                <div class="UNFAPP-grd-radiobx">11th</div>
                                            </label>
                                        </li>
                                        <li>
                                            <label class="UNFAPP-grd-radio">
                                                <input type="radio" name="grade">
                                                <div class="UNFAPP-grd-radiobx">12th</div>
                                            </label>
                                        </li>
                                        <li>
                                            <label class="UNFAPP-grd-radio">
                                                <input type="radio" name="grade">
                                                <div class="UNFAPP-grd-radiobx">13th</div>
                                            </label>
                                        </li>
                                    </ul>
                                </div>
                        
                        
                                <div class="UNFAPP-update-txt text-center">
                                    <label class="whtapp-custom-checkbox">
                                        <input type="checkbox"> <span>Receive updates on Whatsapp</span>
                                    </label>
                                </div>
                                <p class="UNFAPP-terms-text">By signing up you agree to our <a href="#">T&C</a> and <a href="#">Privacy
                                        Policy</a>
                                </p>
                        
                                <div class="UNFAPP-frm-actn-area">
                                    <button class="UNFAPP-blue-btn UNFAPP-full-btn">Get OTP</button>
                                </div>
                        
                        
                            </div>
                        </div>
                    </div>
                    <!-- register -->
                    <div class="tab-pane fade show active" id="signin" role="tabpanel">
                        <div class="UNFAPP-tab-wrap">
                            <div class="UNFAPP-loginvia-sectn">
                                <div class="UNFAPP-loginvia-hdngarea">
                                    <h3 class="UNFAPP-loginvia-hdng">Login with Password</h3>
                                    <h4 class="UNFAPP-loginvia-subhdng">Please enter your password to login and get started</h4>
                                </div>
                                <div class="UNFAPP-loginvia-fromarea">


                                    <div class="UNFAPP-form-fld-row">
                                        <div class="UNFAPP-form-fld-wrp UNFAPP-phncuntry-drpdwn UNFAPP-wthicon">
                                            <span class="UNFAPP-frmicon"><img src="images/registration/phone-icon.png" alt="" /></span>
                                            <div class="UNFAPP-phncuntry-fldgrp">
                                                <select>
                                                    <option>+91</option>
                                                    <option>+91</option>
                                                    <option>+91</option>
                                                    <option>+91</option>
                                                    <option>+91</option>
                                                </select>
                                                <input type="text" placeholder="Phone Number" />
                                            </div>
                                        </div>
                                        <label class="UNFAPP-fld-error">*Account already exists, please click on login to continue</label>
                                    </div>


                                    <div class="UNFAPP-form-fld-row">
                                        <div class="UNFAPP-form-fld-wrp UNFAPP-wthicon">
                                            <span class="UNFAPP-frmicon"><img src="images/registration/lock-icon.svg"
                                                    alt="" /></span>
                                            <span class="UNFAPP-frm-eyeicon"><img src="images/registration/eye-icon.svg"
                                                    alt="" /></span>
                                            <input type="password" class="UNFAPP-form-fld" placeholder="Password">
                                        </div>
                                        <label class="UNFAPP-fld-error">Mobile number and Password does not match</label>
                                    </div>
                                    <div class="UNFAPP-forgotpass">
                                        <a href="#" class="UNFAPP-txt-link">FORGOT PASSWORD?</a>
                                    </div>
                                    <div class="UNFAPP-loginvia-actnarea">
                                        <button type="button" class="UNFAPP-blue-btn UNFAPP-full-btn">LOGIN</button>
                                    </div>
                                    <div class="UNFAPP-logwthpass">
                                        <a href="#" class="UNFAPP-txt-link">LOGIN WITH OTP</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    
        </div>
    </div>
</div>